/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EuAiActRiskClassEnum } from './EuAiActRiskClassEnum';
import {
  EuAiActRiskClassEnumFromJSON,
  EuAiActRiskClassEnumFromJSONTyped,
  EuAiActRiskClassEnumToJSON,
} from './EuAiActRiskClassEnum';
import type { MaterialityEnum } from './MaterialityEnum';
import { MaterialityEnumFromJSON, MaterialityEnumFromJSONTyped, MaterialityEnumToJSON } from './MaterialityEnum';

/**
 *
 * @export
 * @interface PatchedUseCaseWrite
 */
export interface PatchedUseCaseWrite {
  /**
   *
   * @type {number}
   * @memberof PatchedUseCaseWrite
   */
  readonly id?: number;
  /**
   *
   * @type {string}
   * @memberof PatchedUseCaseWrite
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedUseCaseWrite
   */
  businessOwner?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedUseCaseWrite
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedUseCaseWrite
   */
  purpose?: string;
  /**
   *
   * @type {Array<number>}
   * @memberof PatchedUseCaseWrite
   */
  department?: Array<number>;
  /**
   *
   * @type {EuAiActRiskClassEnum}
   * @memberof PatchedUseCaseWrite
   */
  euAiActRiskClass?: EuAiActRiskClassEnum;
  /**
   *
   * @type {MaterialityEnum}
   * @memberof PatchedUseCaseWrite
   */
  materiality?: MaterialityEnum | null;
}

/**
 * Check if a given object implements the PatchedUseCaseWrite interface.
 */
export function instanceOfPatchedUseCaseWrite(value: object): value is PatchedUseCaseWrite {
  return true;
}

export function PatchedUseCaseWriteFromJSON(json: any): PatchedUseCaseWrite {
  return PatchedUseCaseWriteFromJSONTyped(json, false);
}

export function PatchedUseCaseWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedUseCaseWrite {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    name: json['name'] == null ? undefined : json['name'],
    businessOwner: json['business_owner'] == null ? undefined : json['business_owner'],
    description: json['description'] == null ? undefined : json['description'],
    purpose: json['purpose'] == null ? undefined : json['purpose'],
    department: json['department'] == null ? undefined : json['department'],
    euAiActRiskClass:
      json['eu_ai_act_risk_class'] == null ? undefined : EuAiActRiskClassEnumFromJSON(json['eu_ai_act_risk_class']),
    materiality: json['materiality'] == null ? undefined : MaterialityEnumFromJSON(json['materiality']),
  };
}

export function PatchedUseCaseWriteToJSON(value?: Omit<PatchedUseCaseWrite, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    business_owner: value['businessOwner'],
    description: value['description'],
    purpose: value['purpose'],
    department: value['department'],
    eu_ai_act_risk_class: EuAiActRiskClassEnumToJSON(value['euAiActRiskClass']),
    materiality: MaterialityEnumToJSON(value['materiality']),
  };
}
